import React from 'react';
import styled from 'styled-components';
import { translate } from '../../../../../common/translation/translate';
import { ForecastIconLoadingUI } from '../common/forecastIconLoadingUI';
import { CardSectionTextLoadingUI } from './cardSectionTextLoadingUI';

interface CardBodyItemLoadingUIProps {
    isDayItem: boolean;
}

export const CardBodyItemLoadingUI = ({ isDayItem = true }: CardBodyItemLoadingUIProps) => {
    const cardItemDayLabel = isDayItem ? translate('day') : translate('night');
    return (
        <Container>
            <ItemWrap>
                <CardSectionTextLoadingUI dayNightLabel={cardItemDayLabel} />
                <IconWrapper>
                    <CardSectionIcon>
                        <ForecastIconLoadingUI />
                    </CardSectionIcon>
                </IconWrapper>
            </ItemWrap>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 89px;
    border-top: 1px solid #eee;
`;

const ItemWrap = styled.div`
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 100%;
    padding: 0 16px;
    white-space: nowrap;
`;

const IconWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 55px;
    height: 100%;
`;

const CardSectionIcon = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height: 55px;
`;